<h2 mat-dialog-title>Cuenta existente</h2>
<div class="mat-divider-container">
  <mat-divider></mat-divider>
</div>
<mat-dialog-content class="mat-typography">
  <h5>El tiempo de activación ha expirado.</h5>
  <h5>Repita el registro.</h5>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <a mat-raised-button color="accent" mat-dialog-close>Entendido</a>
</mat-dialog-actions>
